import actions from '@/system/socket/store/socket.store.actions'
import getters from '@/system/socket/store/socket.store.getters'
import mutations from '@/system/socket/store/socket.store.mutations'

export interface ISocketPayload<T = any> {
  payload?: T
}

export interface ISocketState {
  isConnected: boolean,
  message: string,
  reconnectError: boolean
}

export interface IActionType<ParamType = any> {
  (param?: ParamType): Promise<any>
}

const state: ISocketState = {
  isConnected: false,
  message: '',
  reconnectError: false
}

export default {
  state,
  actions,
  getters,
  mutations
}
